import { AutocompleteInput, AutocompleteInputProps, ReferenceInput } from 'react-admin';

import { B2bContractsQuery, GetB2bContractsOneResponse } from '@Common/types/bo/b2b/contracts';

import { inputDisabledProps } from '@sh4res/bo-common/utils';

type B2bContractSelectInputProps = Omit<
  AutocompleteInputProps<GetB2bContractsOneResponse>,
  'filter' | 'data-testid'
> & {
  source: string;
  reference?: 'b2b/contracts' | 'contracts';
  filter: B2bContractsQuery['filter'];
  optionText?: (record: GetB2bContractsOneResponse) => string;
  disabled?: boolean;
  testId?: string;
};

const idOrFieldFilterToQuery = (fieldName: string) => (value: string) => {
  if (/^\d+$/.test(value)) {
    return { id: parseInt(value) };
  }

  return { [fieldName]: value };
};

const optionTextDefault = (option: GetB2bContractsOneResponse) =>
  `(${option.id}) ${option.contract_number}`;

export const B2bContractSelectInput = ({
  source = 'b2b_contract_id',
  reference = 'b2b/contracts',
  optionText = optionTextDefault,
  isRequired,
  filter,
  validate,
  disabled,
  testId,
  sx,
  ...props
}: B2bContractSelectInputProps) => (
  <ReferenceInput
    source={source}
    reference={reference}
    isRequired={isRequired}
    filter={filter}
    data-testid={`${testId}_ReferenceInput`}
    // do not fetch data if disabled
    enableGetChoices={disabled ? () => false : undefined}>
    <AutocompleteInput
      optionText={optionText}
      filterToQuery={idOrFieldFilterToQuery('contract_number')}
      isRequired={isRequired}
      validate={validate}
      {...props}
      {...inputDisabledProps(disabled ?? false, sx)}
      data-testid={testId}
    />
  </ReferenceInput>
);
